import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Formik, Form } from "formik";

import * as Yup from "yup";

import FormikActionsPanel from "../forms/formik/FormikActionsPanel";
import ConnectionsPanel from "./ConnectionsPanel";

import { OPERATIONS } from "../../constants/operations";

import operationSelector from "../../state/reducers/operations/operationSelector";

// Designed to be used with the withBasicForm HOC

class ConnectionsForm extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    connections: PropTypes.array.isRequired,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onFormikSubmit: PropTypes.func.isRequired,
    renderMessage: PropTypes.func.isRequired,
    apiSuccesses: PropTypes.object,
    violationErrors: PropTypes.object,
    addConnectionAvailability: PropTypes.object.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_allowlist"
  };

  constructor(props) {
    super(props);

    this.state = {
      submissionCount: 0,
      initialValues: {
        connections: get(props, "connections", [])
      }
    };
  }

  static getDerivedStateFromProps(props, state) {
    // only rehydrate initial values if the form hasn't been edited
    if (state.submissionCount === 0) {
      return {
        ...state,
        initialValues: {
          connections: get(props, "connections", [])
        }
      };
    }

    return state;
  }

  // -- VALIDATION -- //

  validationScheme = () => {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      connections: ConnectionsPanel.validationScheme(messages)
    });
  };

  // -- HANDLER -- //

  onFormikSubmit = values => {
    const { connections } = this.state.initialValues;

    const data = {
      connections:
        values.connections !== connections ? values.connections : null
    };

    this.setState({ submissionCount: this.state.submissionCount + 1 }, () => {
      this.props.onFormikSubmit(data);
    });
  };

  // -- RENDER -- //

  render() {
    const {
      connections,
      onCancel,
      onReset,
      onSubmit,
      renderMessage,
      apiSuccesses,
      violationErrors,
      addConnectionAvailability,
      className,
      copyKey,
      copy
    } = this.props;

    return (
      <Formik
        initialValues={this.state.initialValues} // required by semantic-ui react
        enableReinitialize={true}
        validateOnMount={true}
        validationSchema={this.validationScheme()}
        onSubmit={this.onFormikSubmit}
        className={className}
      >
        {formikProps => {
          return (
            <Form className={`ui form clear-both ${className}`}>
              {renderMessage(formikProps, `${copyKey}.validation_message`)}

              <ConnectionsPanel
                id="connections"
                data={connections}
                formikProps={formikProps}
                showAdd={addConnectionAvailability.available}
                apiSuccesses={apiSuccesses}
                apiErrors={violationErrors}
                copyKey={`${copyKey}.connections_panel`}
              />

              <FormikActionsPanel
                onCancel={onCancel}
                reset={true}
                onReset={onReset}
                submit={true}
                useSubmitModal={true}
                onSubmit={onSubmit}
                modalCopy={copy(`${copyKey}.modals`)}
                panelCopy={copy(`${copyKey}.actions_panel`)}
              />
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = (state, props) => ({
  addConnectionAvailability: operationSelector.selectOperationAvailability(
    state,
    props,
    OPERATIONS.ADD_CONNECTION
  )
});

export default connect(mapStateToProps)(ConnectionsForm);
